Auth = require 'db/auth'
PopOver = require 'views/lib/pop-over'
Util = require 'lib/util'
View = require 'view'
track = require 'debug/track'
upNextInfoTemplate = require 'views/templates/up_next_info'

module.exports = class BoardsPageUpNextInfoView extends View
  viewTitleKey: 'up next info'
  tagName: 'div'
  className: ''

  events:
    'click .js-disable-up-next': 'disableUpNext'

  render: ->
    @$el.html upNextInfoTemplate
      memberId: @options.memberId
    @

  disableUpNext: (e) ->
    Util.preventDefault(e)
    Auth.me().dismiss('upNextExperiment')
    track('Boards View', 'Up Next', 'Clicked disable')
    PopOver.popView()
    return



// WEBPACK FOOTER //
// ./app/scripts/views/member/boards-page-up-next-info-view.coffee